import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-c-fix"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "" }, [
      _createElementVNode("path", {
        d: "M8.42,24.12v-4.24c0,0,1.24-0.11,1.34-0.11h6.52v4.47H9.76C9.66,24.24,8.42,24.13,8.42,24.13V24.12z",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M39.17,18.42h-3.34c-0.21,0.23-0.35,0.53-0.35,0.86c0,0.21-0.1,0.4,0,0.58H24.44l-7.08-0.09H9.76c-0.1,0-1.34,0.11-1.34,0.11v0.31L6.71,19.76H5.2l-0.35,0.18v4.11l0.35,0.18h1.51l1.71-0.43v0.31c0,0,1.24,0.11,1.34,0.11h6.52h1.08l7.4-0.09h10.72c-0.1,0.18,0,0.37,0,0.58c0,0.33,0.13,0.63,0.35,0.86h3.34c0.21-0.23,0.35-0.53,0.35-0.86v-5.44C39.52,18.95,39.39,18.65,39.17,18.42z",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M35.49,17.53h-0.86v8.94h0.86V17.53z",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }